module.exports = __webpack_public_path__ + "img/_edyta_jordan_logo_vue.25bcc3c1.png";